import { Axios, AxiosService } from '@/services/Axios';

import { PriceBookEntryVm } from '../../types';

import { PriceBreakDown, PriceBreakDownItemTypes } from './types';

class ProductControllerClass {
  constructor(private APIService: AxiosService) {}

  fetchDesignToOrderProducts = (opportunityId: string) => {
    return this.APIService.get('/products/get-design-to-order-entries/' + opportunityId);
  };

  getPriceBreakdown = (product: PriceBookEntryVm, quantity: number): PriceBreakDown => {
    return product.product.isCustom
      ? this.getPriceBreakdownForCustomProduct(product, quantity)
      : this.getPriceBreakdownForKitProduct(product);
  };

  getPriceBreakdownForKitProduct = (product: PriceBookEntryVm): PriceBreakDown => {
    return {
      items: [
        {
          code: product.name ?? '',
          title: product.product.portalName,
          type: PriceBreakDownItemTypes.Product,
          price: Number(product.unitPrice),
        },
      ],
      tax: null,
    };
  };

  getPriceBreakdownForCustomProduct = (
    product: PriceBookEntryVm,
    quantity: number,
  ): PriceBreakDown => {
    const discountAmount = product.discountAmount ?? 0;
    const quantityDiscountThreshold = product.quantityDiscountThreshold ?? 0;
    const isDiscountApplied = quantity >= quantityDiscountThreshold;
    const price = isDiscountApplied
      ? Number(product.unitPrice) - Number(discountAmount)
      : Number(product.unitPrice);

    return {
      items: [
        {
          code: 'panels',
          title: 'Panels',
          type: PriceBreakDownItemTypes.Product,
          price,
        },
      ],
      tax: null,
    };
  };
}

export const ProductController = new ProductControllerClass(Axios);
